<template>
  <div class="chat-history-wrapper">
    <div v-if="isLoading" class="loading-indicator">
      {{ loadingText }}
    </div>
    <div class="chat-history" ref="chatHistoryRef">
      <ChatMessage
        v-for="(message, index) in messages"
        :key="index"
        :message="message"
        :bot-avatar="botAvatar"
        :bot-avatar-alt="botAvatarAlt"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChatMessage from './ChatMessage.vue';

export default {
  name: 'ChatHistory',
  components: {
    ChatMessage,
  },
  props: {
    loadingText: {
      type: String,
      default: 'Aguarde enquanto sua mensagem é processada.',
    },
    botAvatar: {
      type: String,
      default: null,
    },
    botAvatarAlt: {
      type: String,
      default: 'Bot avatar',
    },
  },
  computed: {
    ...mapGetters('chat', ['messages', 'isLoading']),
  },
  watch: {
    messages: {
      handler(newMessages, oldMessages) {
        this.$nextTick(() => {
          // Check if bot response was added (new documents in the first message)
          if (newMessages.length > 0 && newMessages[0]?.bot?.documents?.length > 0) {
            const hasNewBotResponse = !oldMessages || 
              newMessages[0].bot.documents.length > (oldMessages[0]?.bot?.documents?.length || 0);
            
            if (hasNewBotResponse) {
              this.scrollToTop();
            }
          }
        });
      },
      deep: true,
    },
    isLoading(newVal, oldVal) {
      // When loading finishes and there are messages, scroll to top
      if (oldVal && !newVal && this.messages.length > 0) {
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
  },
  methods: {
    scrollToTop() {
      if (this.$refs.chatHistoryRef) {
        const hasScrollbar = this.$refs.chatHistoryRef.scrollHeight > this.$refs.chatHistoryRef.clientHeight;
        if (hasScrollbar) {
          this.$refs.chatHistoryRef.scrollTop = 0;
        }
      }
    },
  },
};
</script>

<style scoped>
.chat-history-wrapper {
  background-color: #f5f5f5;
  border-radius: 24px;
  padding: 2vh 1vw;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.loading-indicator {
  color: #01C5AD;
  font-weight: bold;
  margin: 2vh 0;
  font-family: "Montserrat", Sans-serif;
}

.chat-history {
  flex: 1;
  overflow-y: scroll;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 10px;
}

.chat-history::-webkit-scrollbar {
  width: 5px;
}

.chat-history::-webkit-scrollbar-track {
  background: #ffffff;
}

.chat-history::-webkit-scrollbar-thumb {
  background: #2c3e50;
  width: 10px;
}

.chat-history::-webkit-scrollbar-thumb:hover {
  background: #2c3e50;
}

.chat-history::-webkit-scrollbar-button {
  display: none;
}

@media only screen and (max-width: 600px) {
  .loading-indicator {
    font-size: 14px;
  }
}
</style>

